export enum HandoffDistributionMethod {
  SpecificUser = 'SpecificUser',
  RoundRobin = 'RoundRobin',
  IntakeQueue = 'IntakeQueue',
}
